import Panel from './panel/_Panel';
import PanelBody from './panel/_PanelBody';
import PanelHeader from './panel/_PanelHeader';
import SimplePanel from './panel/_SimplePanel';

export { Panel, PanelBody, PanelHeader, SimplePanel };



// WEBPACK FOOTER //
// ./app/components/shared/_panel.js